(function () {
  if (window.__gtInit) return;
  window.__gtInit = true;

  function parseTiers(s) {
    return s.split(',').map(function (t) { var p = t.split(':'); return { q: parseInt(p[0], 10), off: parseInt(p[1], 10) || 0 }; });
  }

  /* Staffel auf der Produktseite: markiert die passende Karte zur gewaehlten Menge (Button ohne Preis) */
  function staffel() {
    var box = document.querySelector('[data-gt]');
    if (!box) return;
    var input = document.getElementById(box.dataset.input);
    if (!input) return;
    var tiers = parseTiers(box.dataset.tiers);
    var cards = box.querySelectorAll('[data-qty]');

    function update() {
      var q = Math.max(1, parseInt(input.value, 10) || 1);
      var active = tiers[0].q;
      tiers.forEach(function (t) { if (q >= t.q) active = t.q; });
      cards.forEach(function (c) {
        var on = parseInt(c.dataset.qty, 10) === active;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        input.value = c.dataset.qty;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        update();
      });
    });
    input.addEventListener('change', update);
    input.addEventListener('input', update);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(update, 0);
    });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', staffel); else staffel();
})();
